class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.context = this.dataset.context || 'drawer';
    this.input = this.querySelector('.cart-discount__input');
    this.applyButton = this.querySelector('.cart-discount__apply');
    this.errorWrapper = this.querySelector('.cart-discount__error');
    this.errorText = this.querySelector('.cart-discount__error-text');
    if (!this.input || !this.applyButton) return;

    this.applyButton.addEventListener('click', () => this.applyDiscount());
    this.input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.applyDiscount();
    });
    this.input.addEventListener('input', () => this.hideError());
    this.querySelectorAll('.cart-discount__remove').forEach((button) => {
      button.addEventListener('click', () => {
        const remaining = this.appliedCodes.filter((code) => code !== button.dataset.code);
        this.updateDiscounts(remaining, null);
      });
    });
  }

  get appliedCodes() {
    return (this.dataset.codes || '').split(',').filter((code) => code !== '');
  }

  applyDiscount() {
    const code = this.input.value.trim();
    if (code === '') return;
    const isDuplicate = this.appliedCodes.some((applied) => applied.toLowerCase() === code.toLowerCase());
    if (isDuplicate) {
      this.showError(this.dataset.errorDuplicate);
      return;
    }
    this.updateDiscounts(this.appliedCodes.concat(code), code);
  }

  getSectionsToRender() {
    if (this.context === 'page') {
      const sections = [{ section: 'cart-icon-bubble', id: 'cart-icon-bubble', selector: '.shopify-section' }];
      const cartItems = document.getElementById('main-cart-items');
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartItems) sections.push({ section: cartItems.dataset.id, id: 'main-cart-items', selector: '.js-contents' });
      if (cartFooter) sections.push({ section: cartFooter.dataset.id, id: 'main-cart-footer', selector: null });
      return sections;
    }
    return [
      { section: 'cart-drawer', id: 'CartDrawer', selector: '.drawer__inner' },
      { section: 'cart-icon-bubble', id: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }

  updateDiscounts(codes, newCode) {
    this.hideError();
    this.setLoading(true);
    const sectionsToRender = this.getSectionsToRender();
    const body = JSON.stringify({
      discount: codes.join(','),
      sections: sectionsToRender.map((sectionToRender) => sectionToRender.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((cart) => {
        if (newCode) {
          const applied = (cart.discount_codes || []).find(
            (discount) => discount.code.toLowerCase() === newCode.toLowerCase()
          );
          if (!applied || !applied.applicable) {
            const revertBody = JSON.stringify({ discount: this.appliedCodes.join(',') });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: revertBody } });
            this.showError(this.dataset.errorInvalid);
            return;
          }
        }
        this.renderSections(cart, sectionsToRender);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: cart });
        }
      })
      .catch(() => this.showError(this.dataset.errorGeneric))
      .finally(() => this.setLoading(false));
  }

  renderSections(cart, sectionsToRender) {
    if (!cart.sections) return;
    sectionsToRender.forEach(({ section, id, selector }) => {
      const container = document.getElementById(id);
      const html = cart.sections[section];
      if (!container || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const target = (selector && container.querySelector(selector)) || container;
      const source = selector ? doc.querySelector(selector) : doc.getElementById(id);
      if (source) target.innerHTML = source.innerHTML;
    });
    const details = document.getElementById(`Details-CartDiscount-${this.context}`);
    if (details) {
      details.setAttribute('open', '');
      const input = details.querySelector('.cart-discount__input');
      if (input) input.focus();
    }
  }

  showError(message) {
    if (!this.errorWrapper) return;
    const decoded = new DOMParser().parseFromString(message, 'text/html').documentElement.textContent;
    this.errorText.textContent = decoded;
    this.errorWrapper.hidden = false;
  }

  hideError() {
    if (!this.errorWrapper) return;
    this.errorWrapper.hidden = true;
  }

  setLoading(isLoading) {
    this.applyButton.toggleAttribute('disabled', isLoading);
    this.applyButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }
}

if (!customElements.get('cart-discount')) {
  customElements.define('cart-discount', CartDiscount);
}
